import React from 'react';
import PropTypes from 'prop-types';
import MuiBox from '@material-ui/core/Box';
import MuiPaper from '@material-ui/core/Paper';
import MuiTypography from '@material-ui/core/Typography';

// `cardTitle` is optional: when set it renders as a heading above the content.
const Card = ({ cardTitle, children, ...props }) => {
  return (
    <MuiPaper {...props}>
      <MuiBox p={2}>
        {cardTitle && (
          <MuiBox mb={3}>
            <MuiTypography variant="h6">{cardTitle}</MuiTypography>
          </MuiBox>
        )}
        {children}
      </MuiBox>
    </MuiPaper>
  );
};

Card.propTypes = {
  cardTitle: PropTypes.string,
  children: PropTypes.node,
};

export default Card;
